export function shouldPlayTransitionChime({ audioUnlocked }) {
  return audioUnlocked
}

export function shouldNotifyTransition({ notificationsGranted }) {
  return notificationsGranted
}

export function transitionNotificationBody({ fromLabel, toLabel }) {
  const from = fromLabel || "Activity"
  const to = toLabel || "the next activity"

  return `${from} completed — switch to ${to} now`
}

export function transitionNotifyKey(detail) {
  const fromLabel = detail.fromLabel || "Activity"
  const toLabel = detail.toLabel || "the next activity"

  return `${detail.from ?? "?"}-${detail.to ?? "?"}-${fromLabel}-${toLabel}`
}
